import { Tooltip, tooltipClasses } from '@mui/material';
import { styled } from '@mui/styles';

export const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip arrow {...props} classes={{ popper: className }} />
))(({ theme, width }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: width || 250,
    padding: theme.spacing(1.5),
    fontSize: theme.typography.pxToRem(13),
  },
}));
